// @flow

import React from 'react';

import { formatDeadlineDates, formatDeadlineTime } from 'client/utils/enrollmentPeriods';

import { DEADLINE_TRANSLATE_PREFIX } from 'routes/cart/components/deadline/DeadlineWarning';
import { DeadlineTranslate } from 'routes/cart/components/shared';
import type { CartDeadlineTranslationsType } from 'routes/cart/types';

type Props = {
  effectiveDate: Date,
  strideEndDate: Date,
  translations: CartDeadlineTranslationsType,
};

const NearCutoffWarning = ({ effectiveDate, strideEndDate, translations }: Props) => {
  const { nearCutoff, nearCutoffIcon } = translations;
  const using = {
    strideEndDate: formatDeadlineDates(strideEndDate),
    strideEndTime: formatDeadlineTime(strideEndDate),
    effectiveDate: formatDeadlineDates(effectiveDate),
  };
  return (
    <React.Fragment>
      {nearCutoffIcon && (
        <div className="pad-y">
          <img alt="nearCutoff" src={nearCutoffIcon.file.url} />
        </div>
      )}
      {nearCutoff && (
        <DeadlineTranslate path={`${DEADLINE_TRANSLATE_PREFIX}.nearCutoff`} using={using} />
      )}
    </React.Fragment>
  );
};

export default NearCutoffWarning;
